import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import { HttpService } from 'services/http.service';
import { WCKOccurrenceModel } from 'services/models/corporate/workcheck/wck-occurrence.model';
import { ServiceBase } from 'services/servicebase';
import { Response } from 'services/models/response';
import { ToastService } from '@core/components/toasts/toasts.service';
import { QueryParams } from 'services/models/odata/queryParams';
import { ActionPlanModel } from 'services/models/corporate/action-plan/action-plan.model';

@Injectable({
  providedIn: 'root',
})
export class WCKOccurrenceService extends ServiceBase<WCKOccurrenceModel> {
  constructor(
    http: HttpService,
    public _toasterService: ToastService
  ) {
    super('workcheck/occurrences', http, environment.apiUrl);
  }

  createEntity(input: any): WCKOccurrenceModel {
    return WCKOccurrenceModel.create(input);
  }

  public createOrUpdate(data: any): Observable<any> {
    if (data?.id) {
      return this.http.put(`${this.endpoint}/update`, data);
    }

    return this.http.post(`${this.endpoint}/create`, data, null, null, true);
  }

  public processTemporaryFile(data: any, options: any): Observable<any> {
    return this.http.post(`${this.endpoint}/upload-file`, data, options, null, true);
  }

  public getOccurrenceFile(id: string) {
    this.http.get(`${this.endpoint}/${id}/file`).subscribe(
      ({ body }) => {
        window.open(body, '_blank');
      },
      error => {
        console.log('error service', error);
      }
    );
  }

  public listByLoggedEmployee(
    queryParams: QueryParams
  ): Observable<Response<WCKOccurrenceModel[]>> {
    const query = this.createBuildQuery(queryParams);
    return this.http
      .get(`${this.endpoint}/list-by-logged-employee${query}`, null, null, null, true)
      .pipe(
        map(res => {
          const response = new Response<WCKOccurrenceModel[]>();
          response.data = res.body.map(pp => WCKOccurrenceModel.create(pp));
          response.count = res.headers.get('x-count');
          return response;
        })
      );
  }
}
